import React from "react";
import { LineChart } from "@mui/x-charts/LineChart";
import "./LineChartAnalysis.css";

export const LineChartAnalysis = ({
  xAxis,
  series,
  width = 400,
  height = 400,
  header = null,
}) => {
  return (
    <div className="line-chart-container">
      {header !== null && <div className="chart-header">{header}</div>}
      {/* `width` is the chart's maximum width; below it the chart follows
          its container so it never overflows narrow columns/screens. */}
      <div className="line-chart" style={{ width: "100%", maxWidth: width }}>
        <LineChart xAxis={xAxis} series={series} height={height} />
      </div>
    </div>
  );
};
